import React from 'react'
import { DesiredShippingDate } from 'src/Libs/shop'
import { ShopSystemConfigurationTypes } from 'src/Libs/shop/types'
import BasicSystem from 'src/Libs/shop/components/SystemConfiguration/BasicSystem'
import { useShopQntmBasicSystem } from '../hooks/use-shop-qntm-basic-system'
import QntmBasicSystemTableMonthCell from './QntmBasicSystemTableMonthCellWrapper'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'

interface QntmBasicSystemWrapperProps {
  desiredShippingDate?: DesiredShippingDate | null
  cartSystemConfigurationIds: string[] | undefined
  existingSystemConfigurationType?: ShopSystemConfigurationTypes
}
/*
 * Wrapper for Basic System step using hook and custom month cell
 */
const QntmBasicSystemWrapper: React.FC<QntmBasicSystemWrapperProps> = ({
  existingSystemConfigurationType,
  desiredShippingDate,
  cartSystemConfigurationIds,
}) => {
  const { t } = useCustomTranslation()
  const { onBack, isLoading, productData, totalMonths, totalProducts, existingSystemConfiguratorShippingDate, handleBasicSystemConfigurationChange } =
    useShopQntmBasicSystem({
      desiredShippingDate,
    })

  return (
    <BasicSystem
      title={t('shop.basic-system.title')}
      onBack={onBack}
      isLoading={isLoading}
      productData={productData}
      existingSystemConfiguratorShippingDate={existingSystemConfiguratorShippingDate}
      cartSystemConfigurationIds={cartSystemConfigurationIds}
      existingSystemConfigurationType={existingSystemConfigurationType}
      handleBasicSystemConfigurationChange={handleBasicSystemConfigurationChange}
      totalMonths={totalMonths}
      totalProducts={totalProducts}
      MonthCellComponent={QntmBasicSystemTableMonthCell}
    />
  )
}

export default QntmBasicSystemWrapper
